/* eslint-disable @typescript-eslint/no-var-requires */
// required by cypress so must use CommonJS module syntax
const { TRIDENT_ROUTE_COMPOSER_UI } = require('./constants')

// TODO: Restore the Alpha and Beta versions of the app
const isDraftAPIStateful = TRIDENT_ROUTE_COMPOSER_UI === '/composer-alpha'

module.exports = {
  draftApiStateful: {
    enabled: [
      // Note that you may need to remove this line manually to test Draft API stateful calls
      ...(isDraftAPIStateful ? ['staging:sandbox'] : []),
    ],
  },
}
